import type { FC } from 'react';
import { useEffect } from 'react';

import { SectionBrandmanager } from '../../components/section-brandmanager/section-brandmanager';
import { SectionCompaniesByIndustries } from '../../components/section-companies-by-industry/section-companies-by-industry';
import { SectionManagedCompanies } from '../../components/section-managed-companies/section-managed-companies';
import { SectionRecommendedCompanies } from '../../components/section-recommended-companies/section-recommended-companies';
import { useTrackPage } from '../../hooks/use-track-page';
import {
  pagesTrackingName,
  useNwtTrackingCompanies,
} from '../../utils/tracking';

import * as Styled from './logged-in-landing-page.styles';

export const LoggedInLandingPage: FC = () => {
  const trackNwtEvent = useNwtTrackingCompanies();
  const pageName = pagesTrackingName.landing;
  const trackingPage = 'companies/overview';

  useTrackPage({ pageName });

  useEffect(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      page: 'companies/overview',
      event: 'viewed_screen',
    });
  }, []);

  return (
    <Styled.Wrapper data-testid="LOGGED-IN-LANDING-PAGE">
      <SectionBrandmanager />
      <SectionManagedCompanies trackingPage={trackingPage} />
      <SectionRecommendedCompanies trackingPage={trackingPage} />
      <SectionCompaniesByIndustries />
    </Styled.Wrapper>
  );
};
